import { replaceAllComplex } from '../../../../mol_function';

export { default as facebookIMG } from './Parts/images/Facebook.png';
export { default as twitterIMG } from './Parts/images/Twitter.png';
export { default as pinterestIMG } from './Parts/images/Pinterest.png';
export { default as informationIMG } from './Parts/images/At.png';

export function getKalenderSubtitel(
  getProp: (name: string) => any,
  getTittleHtml: () => JSX.Element,
  getTitelzusatzHtml: () => JSX.Element,
) {
  let htmlMarke = null;
  let attributeMarke = getProp('Marke');
  if (attributeMarke != null && attributeMarke.value != null) {
    htmlMarke = (
      <>
        <a
          href={
            '/Marke/' +
            replaceAllComplex(attributeMarke.value, [
              { s: '/', r: '___' },
              { s: '&', r: '_-_' },
              { s: '?', r: '%3F' },
              { s: '!', r: '0_0' },
            ]) +
            '/s/'
          }
          title={'stöbern Sie in ' + attributeMarke.value + '.'}
        >
          {attributeMarke.value}
        </a>
        <br />{' '}
      </>
    );
  }

  return (
    <>
      <span className="titel_head">
        <span className="titel">{getTittleHtml()}</span>
        {htmlMarke}
        {/* 
          <span className="titel_sub">{getTitelzusatzHtml()}</span>
          */}
      </span>
    </>
  );
}

export function allowKeysAttribute(allkeys: string[]) {
  return [
    'Titel',
    'Marke',
    'Verlag',
    'Groesse',
    'Kalendarium',
    'Seiten',
    'Sprache',
    'Ausstattung',
    'Kalenderart',
    'Kalenderausrichtung',
    'Kalenderthema',
    'Features',
    'Erscheinungsdatum',
    'Hersteller Artikelnummer',
    'EAN',
    'Nachfolger',
    'Verantwortlich für dieses Produkt',
    getShopArticleLabelPrefix() + '-Artikelnummer',
  ];
}

export function getShopArticleLabelPrefix() {
  return 'Kalenderhaus';
}

export function getVorbestellenSnipped() {
  return (
    <div
      style={{
        color: '#8a0808',
        textTransform: 'uppercase',
        fontSize: 'larger',
        fontWeight: 'bold',
      }}
    >
      Vorbestellen
    </div>
  );
}

export function getPODSnipped() {
  return (
    <div
      style={{
        color: '#8a0808',
        textTransform: 'uppercase',
        fontSize: 'larger',
        fontWeight: 'bold',
      }}
    >
      Print on Demand
    </div>
  );
}
